import z from 'zod';

import { isoDateSchema } from './date';

export const AI_TRANSACTION_COA_TYPES = ['CATEGORY', 'TRANSFER', 'BALANCE_ADJUSTMENT', 'UNCATEGORIZED'] as const;

export const searchTransactionsArgsSchema = z.object({
  accountId: z.string().optional(),
  category: z.string().optional(),
  coaType: z.enum(AI_TRANSACTION_COA_TYPES).optional(),
  dateFrom: isoDateSchema.optional(),
  dateTo: isoDateSchema.optional(),
  keyword: z.string().optional(),
  limit: z.number().int().min(1).optional(),
  maxAmount: z.number().optional(),
  minAmount: z.number().optional(),
  payee: z.string().optional(),
});

export type SearchTransactionsArgs = z.infer<typeof searchTransactionsArgsSchema>;
